/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HourInputs */

const cs_enum_hour = /** @type {(inputs: Enum_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hodina`)
};

const en_enum_hour = /** @type {(inputs: Enum_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hour`)
};

/**
* | output |
* | --- |
* | "hour" |
*
* @param {Enum_HourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_hour = /** @type {((inputs?: Enum_HourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_hour(inputs)
	return cs_enum_hour(inputs)
});